module.exports = __webpack_public_path__ + "img/EASTASIA_PROCESSED_MEATS.4bdec1ef.png";